import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AddAssetsToShareMutationVariables = Types.Exact<{
  assetIds: Array<Types.Scalars['ID']['input']>;
  shareId: Types.Scalars['ID']['input'];
  shareRestrictedAssets?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type AddAssetsToShareMutation = { __typename?: 'Mutation', addAssetsToShare?: { __typename?: 'AddAssetsToSharePayload', metadata?: { __typename?: 'AddAssetsToShareMetadata', addedAssetIds: Array<string> } | null, share?: { __typename?: 'AdHocAssetsShare', id: string, name: string, aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number }, thumbnailAssets?: Array<{ __typename?: 'InboxItemAsset', id?: string | null, assetType?: Types.AssetTypeEnum | null } | null> | null } | { __typename?: 'CollectionShare', id: string, name: string, aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number } } | null } | null };


export const AddAssetsToShare = /*#__PURE__*/ gql`
    mutation AddAssetsToShare($assetIds: [ID!]!, $shareId: ID!, $shareRestrictedAssets: Boolean) {
  addAssetsToShare(
    input: {assetIds: $assetIds, shareId: $shareId, shareRestrictedAssets: $shareRestrictedAssets}
  ) {
    metadata {
      addedAssetIds
    }
    share {
      id
      name
      ... on AssetAggregate {
        aggregationInfo {
          fileCount
          folderCount
        }
      }
      ... on AdHocAssetsShare {
        thumbnailAssets {
          id
          assetType
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<AddAssetsToShareMutation, AddAssetsToShareMutationVariables>;

          

          export const useAddAssetsToShareMutation = (options?:MutationHookOptions<AddAssetsToShareMutation, AddAssetsToShareMutationVariables>) => useMutation(AddAssetsToShare, options);
          

          export type AddAssetsToShareMutationOptions = MutationHookOptions<AddAssetsToShareMutation, AddAssetsToShareMutationVariables>;

          

          export type AddAssetsToShareMutationResult = ReturnType<typeof useAddAssetsToShareMutation>[1];

          
